import axios from "axios";
import {
  createCourierRequestData,
  createAirFreightRequestData,
  createSeaFreightRequestData,
  createRailFreightRequestData,
  createRoadTransportRequestData,
  createRelocationRequestData
} from '../utils/formDataMapper';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.shipperswise.com";

const sendWithAuth = async (url, data) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(`${BASE_URL}${url}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};


const sendCourierRequest = async (formData) => {
  const courierRequestData = createCourierRequestData(formData);
  return sendWithAuth('/courier-requests', courierRequestData);
};

const sendAirFreightRequest = async (formData) => {
  const airFreightRequestData = createAirFreightRequestData(formData);
  return sendWithAuth('/air-freight-requests', airFreightRequestData);
};

const sendSeaFreightRequest = async (formData) => {
  const seaFreightRequestData = createSeaFreightRequestData(formData);
  return sendWithAuth('/sea-freight-requests', seaFreightRequestData);
};
const sendRailFreightRequest = async (formData) => {
  const railFreightRequestData = createRailFreightRequestData(formData);
  return sendWithAuth('/rail-freight-requests', railFreightRequestData);
};
const sendRoadTransportRequest = async (formData) => {
  const roadTransportRequestData = createRoadTransportRequestData(formData);
  return sendWithAuth('/road-requests', roadTransportRequestData);
};
const sendRelocationRequest = async (formData) => {
  const relocationRequestData = createRelocationRequestData(formData);
  return sendWithAuth('/relocation-requests', relocationRequestData);
};

export const sendRequest = async (serviceType, formData) => {
  switch (serviceType) {
    case "courier":
      return await sendCourierRequest(formData);
    case "air-freight":
      return await sendAirFreightRequest(formData);
    case "sea-freight":
      return await sendSeaFreightRequest(formData);
    case "rail-freight":
      return await sendRailFreightRequest(formData);
    case "road-transport":
      return await sendRoadTransportRequest(formData);
    case "relocation":
      return await sendRelocationRequest(formData);
    default:
      throw new Error("Invalid service type");
  }
};
